import { Disclaimer, Div, P, displayCentsInDollars } from '@vgrubs/components';
import { VDrivePaymentMode } from '../../types/api/vDrive.types';
import { Radio } from '../Radio/Radio';
import { ModeOption } from './VDrivePaymentModeOptions.styled';

type Props = {
  value: VDrivePaymentMode;
  onChange: (mode: VDrivePaymentMode) => void;
  /** The auto-recharge amount, in cents: what a top-up adds up front. */
  topUpAmount: number;
  disabled?: boolean;
};

/** "Pay per delivery" or "Prepaid balance", per delivery first (the default). */
export const VDrivePaymentModeOptions = ({
  value,
  onChange,
  topUpAmount,
  disabled,
}: Props) => {
  const options = [
    {
      mode: VDrivePaymentMode.perDelivery,
      title: 'Pay per delivery',
      text: 'No money up front. Each delivery is charged to your card.',
    },
    {
      mode: VDrivePaymentMode.topUp,
      title: 'Prepaid balance (top-up)',
      text: `Add ${displayCentsInDollars(
        topUpAmount
      )} up front and save on card processing fees.`,
    },
  ];

  return (
    <Div $flex $column $gap="12px" $width="100%">
      {options.map(({ mode, title, text }) => {
        const checked = value === mode;
        const pick = () => !disabled && !checked && onChange(mode);
        return (
          <ModeOption
            key={mode}
            $checked={checked}
            $disabled={disabled}
            role="radio"
            aria-checked={checked}
            aria-disabled={disabled}
            tabIndex={disabled ? -1 : 0}
            onClick={pick}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                pick();
              }
            }}
          >
            <Div $flex $column $gap="4px" $width="100%">
              <P $m="0" $bold>
                {title}
              </P>
              <Disclaimer $m="0">{text}</Disclaimer>
            </Div>
            <Radio checked={checked} disabled={disabled} />
          </ModeOption>
        );
      })}
    </Div>
  );
};
